<template>
    <div>
      <header>
        <div class="w-100 bg-introduction" :class="{ 'sticky': isSticky }">
        <div class="container autoContent">
          <div class="row padding-top-bottom">
             <div class="col-xl-2 col-6 col-md-2 
             logo-col">
               <div class="logo w-100 d-inline-block">
                 <router-link to="/" exact-active-class="active-link">
                   <img :src="logoSrc" alt="picture">
                 </router-link>
               </div>
             </div>
             <div class="col-xl-5 col-5 col-md-5 ps-xl-0">
              <div class="float-end menu-button d-xl-none d-block mt-2 d-md-none" @click="toggleSidebar">
                <img src="@/assets/images/menu-button-image.png" alt="picture">
              </div>
              <!-- <transition name="fade" mode="out-in">
                <div :key="sidebarOpen">
                <div class="float-end menu-button d-xl-none d-block mt-2 d-md-none" @click="toggleSidebar" v-if="!sidebarOpen">
                  <img src="@/assets/images/menu-button-image.png" alt="picture">
                </div>
                <div v-else class="float-end 
                cross-icon-image d-xl-none d-block mt-2 d-md-none" @click="closeSidebar">
                  <img class="h-40" src="@/assets/images/cross-icon-image.png" alt="picture">
                </div>
              </div>
              </transition> -->
               <div class="pets-nav w-100 d-xl-inline-block d-none position-relative d-md-block">
                 <nav class="navbar navbar-expand-lg p-0 margin-top-2">
                    <div class="w-100 d-inline-block">
                      <ul class="navbar-nav me-auto mb-2 mb-lg-0 position-relative">
                        <li class="nav-item margin-nav-right-2 nav-text-link">
                          <!-- <a class="nav-link text-black text-size-15 medium-family active nav-text" href="javascript:void(0)">Home
                          </a> -->
                          <router-link class="nav-link text-black text-size-13 medium-family nav-text text-full-13 ps-xl-0" to="/" exact-active-class="active-link">Home</router-link>
                        </li>
                        <li class="nav-item margin-nav-right-3 nav-text-link">
                          <router-link class="nav-link text-black text-size-13 service-dropdown position-relative medium-family 
                          nav-text position-relative right-border text-full-13" 
                          to="/services/" exact-active-class="active-link">Services</router-link>
                          <div class="service-menu bg-white position-absolute box-shadow rounded-2">
                           <ul class="w-100 d-inline-block ps-0 text-center">
                             <li
                               v-for="(item, idx) in navServiceItems"
                               :key="'desk-' + item.id"
                               class="d-inline-block w-100"
                             >
                               <a
                                 v-if="item.external"
                                 :href="item.to"
                                 class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom w-100 text-uppercase text-decoration-none"
                                 :class="idx < navServiceItems.length - 1 ? 'border-bottom' : ''"
                                 target="_blank"
                                 rel="noopener noreferrer"
                               >{{ item.label }}</a>
                               <router-link
                                 v-else
                                 class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom w-100 text-uppercase"
                                 :class="idx < navServiceItems.length - 1 ? 'border-bottom' : ''"
                                 :to="item.to"
                                 exact-active-class="active-link-service"
                               >{{ item.label }}</router-link>
                             </li>
                           </ul>
                        </div>
                        </li>
                        <li class="nav-item margin-nav-right-2 nav-text-link">
                          <router-link class="nav-link text-black 
                          text-size-13 medium-family nav-text position-relative right-border text-full-13" to="/apply-as-groomer" exact-active-class="active-link">Apply as Groomer</router-link>
                        </li>
                        <li class="nav-item margin-nav-right-3 nav-text-link">
                          <router-link class="nav-link text-black 
                          text-size-13 medium-family nav-text position-relative right-border text-full-13" to="/apply-as-salon" exact-active-class="active-link">Apply as Salon</router-link>
                        </li>
                      </ul>
                    </div>
                </nav>
               </div>
             </div>
             <div class="col-xl-5 col-6 col-md-5 margin-top-1">
               <!-- <div class="pets-nav-btn float-end margin-top-2 d-xl-inline-block d-none d-md-block"> -->
                 <!-- <button type="button" class="text-white text-size-11 bg-call border-0 me-2 inter-semi-bold text-uppercase text-full-11">
                          <img src="@/assets/images/call-icon.svg" 
                          alt="picture" class="me-2">
                          Call Now
                        </button> -->
                        <!-- <button type="button" class="text-white text-size-11 bg-online-book border-0 bg-green inter-semi-bold text-uppercase text-full-11">
                          <img src="@/assets/images/book-online-icon.svg" alt="picture" class="me-2">
                          Book online
                        </button> -->
                        <!-- Desktop/tablet actions (mobile uses its own row below) -->
                        <div class="pets-nav-btn float-end margin-top-2 d-none d-md-inline-flex align-items-center flex-nowrap header-actions">
                          <!-- Call Now Button -->
                          <a href="javascript:void(0)" @click="openCall" class="text-white text-size-11 bg-call border-0 me-2 inter-semi-bold text-uppercase text-full-11 d-inline-block">
                            <img src="@/assets/images/call-icon.svg" alt="picture" class="me-2">
                            Call Now
                          </a>
                          <!-- Book Online Button -->
                          <router-link class="text-white text-size-11 bg-online-book border-0 bg-yellow inter-semi-bold text-uppercase text-full-11 d-inline-block" to="/booking/">
                            <img src="@/assets/images/book-online-icon.svg" alt="picture" class="me-2">
                            Book Online
                          </router-link>
                          <!-- Change Country Button: own class so chevron stays inside pill (not .service-dropdown nav offset) -->
                          <div class="d-inline-block position-relative" v-if="countryNavLabel" ref="countryMenuWrapper">
                            <a
                              class="d-inline-flex align-items-center justify-content-center ms-2 country-flag-trigger"
                              href="javascript:void(0)"
                              aria-label="Change country"
                              @click.stop.prevent="toggleCountryMenu"
                            >
                              <img
                                v-if="currentCountryFlagSrc"
                                :src="currentCountryFlagSrc"
                                alt=""
                                class="country-flag-trigger-img"
                              >
                              <i v-else class="fa fa-globe" aria-hidden="true"></i>
                            </a>
                            <div
                              v-if="countryMenuOpen && countries.length"
                              class="website-menu country-menu-panel bg-white position-absolute box-shadow rounded-2"
                              style="opacity: 1; pointer-events: auto; z-index: 9999;"
                            >
                              <ul class="w-100 d-inline-block ps-0 text-center">
                                <li
                                  v-for="country in countries"
                                  :key="country.id"
                                  class="d-inline-block w-100"
                                >
                                  <a
                                    class="nav-color text-size-13 medium-family text-full-13 d-inline-flex align-items-center justify-content-center gap-2 padding-top-bottom border-bottom w-100 country-dropdown-link"
                                    href="javascript:void(0)"
                                    @click="selectCountry(country)"
                                  >
                                    <img
                                      v-if="country.flag"
                                      :src="$getImageUrl(country.flag)"
                                      alt=""
                                      class="country-dropdown-flag"
                                    >
                                    <span>{{ country.name }}</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!-- User / Partner login dropdown -->
                          <div class="d-inline-block position-relative ms-2" ref="authMenuWrapper">
                            <a
                              href="javascript:void(0)"
                              class="auth-menu-trigger d-inline-flex align-items-center justify-content-center"
                              aria-label="Account"
                              @click.stop.prevent="toggleAuthMenu"
                            >
                              <i class="fa fa-user text-black" aria-hidden="true"></i>
                            </a>
                            <div v-if="authMenuOpen" class="auth-menu-panel bg-white position-absolute box-shadow rounded-2">
                              <ul class="w-100 d-inline-block ps-0 text-center mb-0">
                                <li class="d-inline-block w-100">
                                  <router-link
                                    v-if="!isPartnerLoggedIn"
                                    class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom border-bottom w-100 text-uppercase text-decoration-none"
                                    to="/login"
                                  >
                                    Login
                                  </router-link>
                                  <router-link
                                    v-else
                                    class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom border-bottom w-100 text-uppercase text-decoration-none"
                                    :to="partnerDashboardPath"
                                  >
                                    Dashboard
                                  </router-link>
                                </li>
                                <li v-if="isPartnerLoggedIn" class="d-inline-block w-100">
                                  <a
                                    class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom w-100 text-uppercase text-decoration-none"
                                    href="javascript:void(0)"
                                    @click="logoutPartner"
                                  >
                                    Logout
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

               <!-- </div> -->
             </div>
          </div>

          <!-- Mobile actions row (prevents wrapping inside desktop grid) -->
          <div class="row d-md-none pb-2">
            <div class="col-12">
              <div class="d-flex justify-content-end align-items-center flex-nowrap header-actions header-actions--mobile">
                <a
                  href="javascript:void(0)"
                  @click="openCall"
                  class="text-white text-size-11 bg-call border-0 inter-semi-bold text-uppercase text-full-11 d-inline-flex align-items-center"
                >
                  <img src="@/assets/images/call-icon.svg" alt="picture" class="me-2">
                  Call Now
                </a>
                <router-link
                  class="text-white text-size-11 bg-online-book border-0 bg-yellow inter-semi-bold text-uppercase text-full-11 d-inline-flex align-items-center"
                  to="/booking/"
                >
                  <img src="@/assets/images/book-online-icon.svg" alt="picture" class="me-2">
                  Book Online
                </router-link>

                <div class="d-inline-block position-relative" v-if="countryNavLabel" ref="countryMenuWrapperMobile">
                  <a
                    class="d-inline-flex align-items-center justify-content-center country-flag-trigger"
                    href="javascript:void(0)"
                    aria-label="Change country"
                    @click.stop.prevent="toggleCountryMenu"
                  >
                    <img
                      v-if="currentCountryFlagSrc"
                      :src="currentCountryFlagSrc"
                      alt=""
                      class="country-flag-trigger-img"
                    >
                    <i v-else class="fa fa-globe" aria-hidden="true"></i>
                  </a>
                  <div
                    v-if="countryMenuOpen && countries.length"
                    class="website-menu country-menu-panel bg-white position-absolute box-shadow rounded-2"
                    style="opacity: 1; pointer-events: auto; z-index: 9999;"
                  >
                    <ul class="w-100 d-inline-block ps-0 text-center">
                      <li
                        v-for="country in countries"
                        :key="country.id"
                        class="d-inline-block w-100"
                      >
                        <a
                          class="nav-color text-size-13 medium-family text-full-13 d-inline-flex align-items-center justify-content-center gap-2 padding-top-bottom border-bottom w-100 country-dropdown-link"
                          href="javascript:void(0)"
                          @click="selectCountry(country)"
                        >
                          <img
                            v-if="country.flag"
                            :src="$getImageUrl(country.flag)"
                            alt=""
                            class="country-dropdown-flag"
                          >
                          <span>{{ country.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="d-inline-block position-relative" ref="authMenuWrapperMobile">
                  <a
                    href="javascript:void(0)"
                    class="auth-menu-trigger d-inline-flex align-items-center justify-content-center"
                    aria-label="Account"
                    @click.stop.prevent="toggleAuthMenu"
                  >
                    <i class="fa fa-user text-black" aria-hidden="true"></i>
                  </a>
                  <div v-if="authMenuOpen" class="auth-menu-panel bg-white position-absolute box-shadow rounded-2">
                    <ul class="w-100 d-inline-block ps-0 text-center mb-0">
                      <li class="d-inline-block w-100">
                        <router-link
                          v-if="!isPartnerLoggedIn"
                          class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom border-bottom w-100 text-uppercase text-decoration-none"
                          to="/login"
                        >
                          Login
                        </router-link>
                        <router-link
                          v-else
                          class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom border-bottom w-100 text-uppercase text-decoration-none"
                          :to="partnerDashboardPath"
                        >
                          Dashboard
                        </router-link>
                      </li>
                      <li v-if="isPartnerLoggedIn" class="d-inline-block w-100">
                        <a
                          class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom w-100 text-uppercase text-decoration-none"
                          href="javascript:void(0)"
                          @click="logoutPartner"
                        >
                          Logout
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="$route.path === '/booking/' || $route.path === '/date'" class="row pb-2">
            <div class="col-12">
                <a class="text-black text-size-18 margin-right-2 text-full-18" href="javascript:void(0)" @click="handleBackNavigation">
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="javascript:void(0)" v-if="$route.path === '/booking/'" class="mb-0 text-size-13 family-inter-light strike-text fw-bold text-full-13">
                  Step 1 of 3
                </a>
                <a href="javascript:void(0)" v-else-if="$route.path === '/date'" class="mb-0 text-size-13 family-inter-light strike-text fw-bold text-full-13">
                  Step 2 of 3
                </a>
            </div>
          </div>
        </div>
      </div>
      </header>
      <div class="d-xl-none sidebar bg-white box-shadow p-2 d-block d-md-none" :class="['sidebar', { 'open': sidebarOpen }]">
            <div class="row">
              <div class="col-6">
                <div class="logo w-100 
                d-inline-block">
                 <router-link to="/" exact-active-class="active-link">
                   <img src="@/assets/images/logo-image.svg" alt="picture">
                 </router-link>
               </div>
              </div>
              <div class="col-6">
                <div class="float-end 
                cross-icon-image" @click="closeSidebar">
                  <img class="h-40" src="@/assets/images/cross-icon-image.png" alt="picture">
                </div>
              </div>
              <div class="col-12">
                <div class="pets-nav w-100 d-xl-inline-none d-block position-relative">
                 <nav class="navbar navbar-expand-lg p-0 mt-2">
                    <div class="w-100 d-inline-block">
                      <ul class="navbar-nav me-auto mb-2 mb-lg-0 position-relative">
                        <li class="nav-item nav-text-link ps-2">
                          <!-- <a class="nav-link text-black text-size-15 medium-family active nav-text" href="javascript:void(0)">Home
                          </a> -->
                          <router-link class="nav-link text-black text-size-17 medium-family nav-text pt-3 pb-3" to="/" exact-active-class="active-link">Home</router-link>
                        </li>
                        <li class="nav-item nav-text-link" ref="accordionWrapper">
    <div class="service-accordion accordion accordion-flush" id="accordionFlushExample">
      <div class="accordion-item">
        <a
          class="nav-link text-black text-size-17 position-relative medium-family nav-text pt-3 ps-2 pe-0 pb-3 service-dropdown-2 accordion-button w-100 d-inline-block"
          :class="{ collapsed: !isAccordionOpen }"
          @click="toggleAccordion"
        >
          Services
        </a>

        <div
          id="flush-collapseOne"
          class="accordion-collapse collapse"
          :class="{ show: isAccordionOpen }"
        >
          <div class="accordion-body p-0 mt-2">
            <div class="border p-2 rounded-3 w-100">
              <ul class="w-100 d-inline-block p-2">
                <li
                  v-for="(item, idx) in navServiceItems"
                  :key="'mob-' + item.id"
                  class="d-inline-block w-100"
                  :class="idx < navServiceItems.length - 1 ? 'pb-3' : ''"
                >
                  <a
                    v-if="item.external"
                    :href="item.to"
                    class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3 text-uppercase text-decoration-none"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{ item.label }}</a>
                  <router-link
                    v-else
                    class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3 text-uppercase"
                    :to="item.to"
                    exact-active-class="active-link-service"
                  >{{ item.label }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
                        <!-- <li class="nav-item nav-text-link">
                          <div class="service-accordion accordion accordion-flush" id="accordionFlushExample">
                            <div class="accordion-item">
                              <a class="nav-link text-black text-size-17 position-relative medium-family nav-text pt-3 ps-2 pe-0 pb-3 service-dropdown-2 accordion-button collapsed w-100 d-inline-block" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">Services
                              </a>
                              <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                              <div class="accordion-body p-0 mt-2">
                                <div class="border p-2 rounded-3 w-100">
                                 <ul class="w-100 d-inline-block 
                                 p-2">
                                   <li class="d-inline-block w-100 pb-3">
                                <router-link class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3" to="/services/mobile-dog-grooming-dubai-pet-groomer/" exact-active-class="active-link-service">DOG GROOMING
                                </router-link>
                                   </li>
                                   <li class="d-inline-block w-100 pb-3">
                                     <router-link class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3" to="/services/mobile-cat-grooming-service-dubai/" exact-active-class="active-link-service">CAT GROOMING</router-link>
                                   </li>
                                   <li class="d-inline-block w-100 pb-3">
                                     <router-link class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3" to="/services/bird-grooming-services-dubai-pet-groomer/" exact-active-class="active-link-service">BIRD GROOMING
                                     </router-link>
                                   </li>
                                   <li class="d-inline-block w-100">
                                   <router-link class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3" to="/services/rabbit-grooming-dubai-mobile-pet-groomer/" exact-active-class="active-link-service">RABBIT GROOMING
                                     </router-link>
                                   </li>
                                 </ul>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </li> -->
                        <li class="nav-item nav-text-link">
                          <router-link class="nav-link text-black text-size-17 medium-family nav-text position-relative right-border pt-3 pb-3 ps-2" to="/apply-as-groomer" exact-active-class="active-link">Apply as Groomer</router-link>
                        </li>
                        <li class="nav-item nav-text-link">
                          <router-link class="nav-link text-black text-size-17 medium-family nav-text position-relative right-border pt-3 pb-3 ps-2" to="/apply-as-salon" exact-active-class="active-link">Apply as Salon</router-link>
                        </li>
                        <li class="nav-item nav-text-link">
                          <router-link class="nav-link text-black text-size-17 medium-family nav-text position-relative right-border pt-3 pb-3 ps-2" to="/services/" exact-active-class="active-link">How it Works
                          </router-link>
                        </li>
                      </ul>
                    </div>
                </nav>
               </div>
               <div class="w-100 d-inline-block 
               mt-2 text-center mb-3 sidebar-btn">
                 <!-- <a href="javascript:void(0)" @click="openCall" class="text-white text-size-15 bg-call-btn border-0 me-2 inter-semi-bold text-uppercase text-full-11">
                  <img src="@/assets/images/call-icon.svg" alt="picture" class="me-2 h-16">
                  Call Now
                </a> -->
                <!-- Book Online Button -->
                <router-link class="text-white text-size-15 bg-book-btn border-0 bg-orange inter-semi-bold text-uppercase text-full-11" to="/booking/">
                  <img src="@/assets/images/book-online-icon.svg" alt="picture" class="me-2 h-16">
                  Book Online
                </router-link>
               </div>
              </div>
            </div>
          </div>
    </div>
  </template>
  
  <script>
  import { readWebsiteNameFromStorage, setCurrentWebsiteName } from '@/utils/currentWebsite';
  import {
    readCountrySlugFromStorage,
    readDefaultCountrySlugFromStorage,
    setCurrentCountrySlug,
    setDefaultCountrySlug,
  } from '@/utils/currentCountry';
  import { withCountryPath } from '@/utils/countryPath';
  import {
    readSelectedWebsiteContactRaw,
    normalizeContactForTel,
  } from '@/utils/websiteContact';
  import { clearPartnerSession } from '@/utils/partnerProfileStorage';
  import { revokePartnerTokenIfAny } from '@/utils/partnerAuthLogout';

  function defaultNavServiceItems() {
    return [
      { id: 'fallback-dog', label: 'Dog Grooming', to: withCountryPath('/services/mobile-dog-grooming-dubai-pet-groomer/'), external: false },
      { id: 'fallback-cat', label: 'Cat Grooming', to: withCountryPath('/services/mobile-cat-grooming-service-dubai/'), external: false },
      { id: 'fallback-bird', label: 'Bird Grooming', to: withCountryPath('/services/bird-grooming-services-dubai-pet-groomer/'), external: false },
      { id: 'fallback-rabbit', label: 'Rabbit Grooming', to: withCountryPath('/services/rabbit-grooming-dubai-mobile-pet-groomer/'), external: false },
    ];
  }

  export default {
    name: 'headerComponent',
    data() {
      return {
        isSticky: false,
        sidebarOpen: false,
        isAccordionOpen: false,
        websites: [],
        countries: [],
        navServiceItems: defaultNavServiceItems(),
        currentWebsiteName: readWebsiteNameFromStorage(),
        currentWebsiteLogo: null,
        currentCountryName: '',
        currentCountryFlag: null,
        countryMenuOpen: false,
        authMenuOpen: false,
        partnerAuth: null,
      };
    },
    computed: {
      logoSrc() {
        if (this.currentWebsiteLogo) return this.$getImageUrl(this.currentWebsiteLogo);
        return require('@/assets/images/logo-image.svg');
      },
      currentCountryFlagSrc() {
        if (!this.currentCountryFlag) return null;
        return this.$getImageUrl(this.currentCountryFlag);
      },
      /** Navbar label: never show generic "Country" placeholder */
      countryNavLabel() {
        const n = (this.currentCountryName || '').trim();
        // Only show real country name (never slug fallback like "login")
        return n || '';
      },
      isPartnerLoggedIn() {
        const jt = String(this.partnerAuth?.joinType || '').toLowerCase();
        return jt === 'salon' || jt === 'groomer' || jt === 'user';
      },
      partnerDashboardPath() {
        const jt = String(this.partnerAuth?.joinType || '').toLowerCase();
        if (jt === 'salon') return '/dashboard/salon';
        if (jt === 'groomer') return '/dashboard/groomer';
        return '/dashboard/user';
      },
    },
    methods: {
      toggleCountryMenu() {
        this.countryMenuOpen = !this.countryMenuOpen;
      },
      toggleAuthMenu() {
        this.authMenuOpen = !this.authMenuOpen;
      },
      hydratePartnerAuthFromStorage() {
        try {
          const stored = JSON.parse(localStorage.getItem('partner_auth') || 'null');
          this.partnerAuth = stored && typeof stored === 'object' ? stored : null;
        } catch {
          this.partnerAuth = null;
        }
      },
      async logoutPartner() {
        await revokePartnerTokenIfAny(this.$axios);
        try {
          clearPartnerSession();
        } catch (_) {
          // ignore
        }
        this.partnerAuth = null;
        this.authMenuOpen = false;
        this.$router.push({ path: '/login' });
      },
      resolveCategoryNavItem(c) {
        const name = (c?.name || 'Service').trim();
        const content = c?.content;
        const rawUrl = typeof content?.service_url === 'string' ? content.service_url.trim() : '';
        if (rawUrl) {
          if (/^https?:\/\//i.test(rawUrl)) {
            return { id: `cat-${c.id}`, label: name, to: rawUrl, external: true };
          }
          const path = rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`;
          return { id: `cat-${c.id}`, label: name, to: withCountryPath(path), external: false };
        }
        const slug = (c?.slug || '').trim();
        return {
          id: `cat-${c.id}`,
          label: name,
          to: slug ? withCountryPath(`/services/${slug}/`) : withCountryPath('/services/'),
          external: false,
        };
      },
      async fetchNavServiceItems() {
        try {
          const form = new URLSearchParams();
          form.append('website_name', this.activeWebsiteName || '');
          const res = await this.$axios.post('/get-categories-home', form);
          if (res?.data?.status === 'success' && Array.isArray(res.data.categories)) {
            const items = res.data.categories
              .filter((c) => c && String(c.status) !== '0')
              .map((c) => this.resolveCategoryNavItem(c));
            this.navServiceItems = items.length ? items : defaultNavServiceItems();
            return;
          }
        } catch (e) {
          // keep or fallback below
        }
        this.navServiceItems = defaultNavServiceItems();
      },
      async fetchWebsites() {
        try {
          const res = await this.$axios.get('/get-websites');
          if (res?.data?.status === 'success') {
            this.websites = Array.isArray(res.data.websites) ? res.data.websites : [];
            localStorage.setItem('websites_cache', JSON.stringify(this.websites));
          }
        } catch (e) {
          // fail silently to avoid UI changes if API not reachable
          try {
            const cached = JSON.parse(localStorage.getItem('websites_cache') || '[]');
            if (Array.isArray(cached) && cached.length) this.websites = cached;
          } catch (_) {
            // ignore
          }
        }
      },
      syncCountryDisplay() {
        const isValidSlug = (s) => /^[a-z][a-z-]{1,15}$/i.test(String(s || '').trim())
          && ![
            'login', 'partner-login', 'partner-login-redirect', 'services', 'booking', 'date', 'payment', 'contact-us',
            'apply-as-groomer', 'apply-as-salon', 'dashboard', 'set-password', 'privacy',
            'termscondition', 'refundpolicy', 'blog', 'about', 'about-us', 'backhome',
          ].includes(String(s || '').toLowerCase().trim());

        let slug = (readCountrySlugFromStorage() || '').toLowerCase().trim();
        let stored = null;
        try {
          stored = JSON.parse(localStorage.getItem('selected_country') || 'null');
        } catch {
          stored = null;
        }

        // Self-heal if stored slug is invalid (e.g. "login")
        if (!isValidSlug(slug)) {
          const storedSlug = String(stored?.slug || '').toLowerCase().trim();
          const storedValid = storedSlug && isValidSlug(storedSlug);
          const defaultSlug = String(readDefaultCountrySlugFromStorage() || '').toLowerCase().trim();
          const defaultValid = defaultSlug && isValidSlug(defaultSlug);

          if (storedValid) {
            slug = storedSlug;
            setCurrentCountrySlug(slug);
          } else if (defaultValid) {
            slug = defaultSlug;
            setCurrentCountrySlug(slug);
          } else {
            // If we can't determine, clear UI so it doesn't show wrong label.
            this.currentCountryName = stored?.name && storedValid ? stored.name : '';
            this.currentCountryFlag = stored?.flag && storedValid ? stored.flag : null;
            return;
          }
        }

        const bySlug = this.countries.find((c) => String(c.slug || '').toLowerCase() === slug);

        if (bySlug) {
          this.currentCountryName = bySlug.name || '';
          this.currentCountryFlag = bySlug.flag || null;
          const stSlug = stored?.slug != null ? String(stored.slug).toLowerCase() : '';
          if (!stored || stSlug !== slug || stored.name !== bySlug.name) {
            localStorage.setItem(
              'selected_country',
              JSON.stringify({
                id: bySlug.id,
                name: bySlug.name,
                code: bySlug.code,
                slug,
                flag: bySlug.flag || null,
              })
            );
          }
          return;
        }

        if (stored && String(stored.slug || '').toLowerCase() === slug && stored.name) {
          this.currentCountryName = stored.name;
          this.currentCountryFlag = stored.flag || null;
          return;
        }

        if (stored?.name) {
          this.currentCountryName = stored.name;
          this.currentCountryFlag = stored.flag || null;
          return;
        }

        this.currentCountryName = '';
        this.currentCountryFlag = null;
      },

      async fetchCountries() {
        try {
          const res = await this.$axios.get('/get-countries');
          if (res?.data?.status === 'success' && Array.isArray(res.data.countries)) {
            this.countries = res.data.countries;
            localStorage.setItem('countries_cache', JSON.stringify(this.countries));
            if (res?.data?.default_country_slug) {
              setDefaultCountrySlug(res.data.default_country_slug);
            }
            this.syncCountryDisplay();
            return;
          }
        } catch (e) {
          // ignore
        }
        try {
          const cached = JSON.parse(localStorage.getItem('countries_cache') || '[]');
          if (Array.isArray(cached) && cached.length) {
            this.countries = cached;
          }
        } catch (_) {
          // ignore
        }
        this.syncCountryDisplay();
      },
      selectWebsite(website) {
        if (!website?.name) return;
        localStorage.setItem(
          'selected_website',
          JSON.stringify({
            name: website.name,
            logo: website.logo || null,
            contact: website.contact || null,
            website_email: website.website_email || null,
            facebook: website.facebook || null,
            instagram: website.instagram || null,
            twitter: website.twitter || null,
            address: website.address || null,
            open_time: website.open_time || null,
            close_time: website.close_time || null,
          })
        );
        localStorage.setItem('website_name', website.name);
        setCurrentWebsiteName(website.name);
        this.currentWebsiteName = website.name;
        this.currentWebsiteLogo = website.logo || null;
        window.location.reload();
      },
      stripCountryPrefixFromPath(fullPath) {
        const p = fullPath || '/';
        const m = p.match(/^\/([a-z]{2,10})(\/|$)/i);
        if (!m) return p;
        const rest = p.slice(m[0].length - 1);
        return rest || '/';
      },
      selectCountry(country) {
        this.countryMenuOpen = false;
        const slug = String(country?.slug || '').toLowerCase().trim();
        if (!slug) return;

        const defaultSlug = (readDefaultCountrySlugFromStorage() || '').toLowerCase().trim();

        // Country changed → clear previously selected booking location
        // so the user picks a location relevant to the new country.
        localStorage.removeItem('cartAddress');
        localStorage.removeItem('booking_cart_pin');

        localStorage.setItem(
          'selected_country',
          JSON.stringify({
            id: country.id,
            name: country.name,
            code: country.code,
            slug,
            flag: country.flag || null,
          })
        );
        setCurrentCountrySlug(slug);
        this.currentCountryName = country.name || '';
        this.currentCountryFlag = country.flag || null;

        const website = country.website;
        if (website?.name) {
          localStorage.setItem(
            'selected_website',
            JSON.stringify({
              name: website.name,
              logo: website.logo || null,
              contact: website.contact || null,
              website_email: website.website_email || null,
              facebook: website.facebook || null,
              instagram: website.instagram || null,
              twitter: website.twitter || null,
              address: website.address || null,
              open_time: website.open_time || null,
              close_time: website.close_time || null,
            })
          );
          localStorage.setItem('website_name', website.name);
          setCurrentWebsiteName(website.name);
          this.currentWebsiteName = website.name;
          this.currentWebsiteLogo = website.logo || null;
        }

        const stripped = this.stripCountryPrefixFromPath(this.$route.fullPath);
        let path = stripped.startsWith('/') ? stripped : `/${stripped}`;
        if (!path || path === '') path = '/';

        let target;
        if (slug === defaultSlug) {
          target = path;
        } else {
          target = path === '/' ? `/${slug}/` : `/${slug}${path}`;
        }
        window.location.assign(target);
      },
      hydrateSelectedWebsiteFromStorage() {
        try {
          const storedWebsite = JSON.parse(localStorage.getItem('selected_website') || 'null');
          if (storedWebsite?.name) this.currentWebsiteName = storedWebsite.name;
          this.currentWebsiteLogo = storedWebsite?.logo || null;
        } catch (e) {
          // ignore
        }
      },
      hydrateSelectedCountryFromStorage() {
        this.syncCountryDisplay();
      },
      toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen;
    },
    handleClickOutside(event) {
      if (
        this.isAccordionOpen &&
        this.$refs.accordionWrapper &&
        !this.$refs.accordionWrapper.contains(event.target)
      ) {
        this.isAccordionOpen = false;
      }

      // Desktop + mobile country wrappers both stay in the DOM (hidden via CSS).
      // Treat a click as "inside" if it hits either wrapper, otherwise the menu closes immediately.
      if (this.countryMenuOpen) {
        const inCountry =
          (this.$refs.countryMenuWrapper && this.$refs.countryMenuWrapper.contains(event.target))
          || (this.$refs.countryMenuWrapperMobile && this.$refs.countryMenuWrapperMobile.contains(event.target));
        if (!inCountry) {
          this.countryMenuOpen = false;
        }
      }

      if (this.authMenuOpen) {
        const inAuth =
          (this.$refs.authMenuWrapper && this.$refs.authMenuWrapper.contains(event.target))
          || (this.$refs.authMenuWrapperMobile && this.$refs.authMenuWrapperMobile.contains(event.target));
        if (!inAuth) {
          this.authMenuOpen = false;
        }
      }
    },
     async openCall() {
        console.log("Call link clicked");
    
        // First, call the API to store the click data
        await this.callClick('call');
    
        // Then open the phone app
        const phoneNumber = normalizeContactForTel(readSelectedWebsiteContactRaw());
        const telUrl = `tel:${phoneNumber}`;
        window.open(telUrl, "_blank");
      },  
      async callClick(method) {
       try {
        const payload = {
          website_name: this.activeWebsiteName,
          type: method,
          ip: 'call',
        
        };
        const response = await this.$axios.post('/click-count', payload);
        console.log('Response:', response.data);
        
      } catch (err) {
        console.error('Error during call click:', err);
      }
    },
      handleBackNavigation() {
      if (this.$route.path === '/booking/') {
        this.$router.push('/');
      } else if (this.$route.path === '/date') {
        this.$router.push('/booking/');
      }
    },
      openWhatsApp() {
    window.dispatchEvent(new CustomEvent('open-whatsapp-chat'));
  },
      handleScroll() {
            const scrollPosition = window.scrollY;
            const offset = 100; // Adjust this value as per your requirement
            if (scrollPosition > offset) {
                this.isSticky = true;
            } else {
                this.isSticky = false;
            }
        },
        toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  },
  closeSidebar() {
    this.sidebarOpen = false;
  }
    },
     async mounted() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener("click", this.handleClickOutside);
    this.hydrateSelectedWebsiteFromStorage();
    this.hydratePartnerAuthFromStorage();
    this.fetchWebsites();
    this.hydrateSelectedCountryFromStorage();
    await this.fetchCountries();
    this.syncCountryDisplay();
    this.fetchNavServiceItems();
  },
  watch: {
    activeWebsiteName() {
      this.fetchNavServiceItems();
    },
    '$route.fullPath'() {
      this.syncCountryDisplay();
    },
    countries: {
      handler() {
        this.syncCountryDisplay();
      },
      deep: true,
    },
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener("click", this.handleClickOutside);
  },
  }
  </script>
  
  <style scoped>
  .header-actions {
    gap: 10px;
  }
  .header-actions--mobile {
    gap: 10px;
    padding-top: 6px;
  }

  .country-menu-panel {
    min-width: 220px;
    width: auto !important;
    left: auto !important;
    right: 0;
  }

  .auth-menu-trigger {
    width: 36px;
    height: 36px;
    border-radius: 999px;
    background: #fff;
    border: 1px solid #fff;
  }
  .auth-menu-trigger i {
    color: #000 !important;
    font-size: 25px;
  }
  
  .auth-menu-panel {
    right: 0;
    top: 44px;
    min-width: 160px;
    z-index: 60;
    opacity: 1;
    pointer-events: auto;
  }

  .country-flag-trigger {
    width: 36px;
    height: 36px;
    border-radius: 999px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: #fff;
    overflow: hidden;
  }
  .country-flag-trigger-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* Mobile top-right buttons like reference */
  @media (max-width: 576px) {
    .header-actions--mobile {
      justify-content: flex-start;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
    }
    .header-actions--mobile::-webkit-scrollbar {
      display: none;
    }
    .bg-call,
    .bg-online-book {
      padding: 10px 14px !important;
      border-radius: 8px !important;
      margin-bottom: 0 !important;
      white-space: nowrap;
    }
    .bg-call img,
    .bg-online-book img {
      height: 16px;
      width: 16px;
    }
    .auth-menu-trigger i {
      font-size: 18px;
    }
  }
  </style>